<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    created() {
        window.getApp.$emit("APP_DRAWER_HIDE");
    },

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 29,
            title: "TIPOS DE PROVEEDORES LOGÍSTICOS",
            columns: ["clave", "descripcion", "actions"],
            options: {
                filterable: ["clave", "descripcion"],
                sortable: ["clave", "descripcion"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion"
            },
            camposLayout: [{
                clave: "[Clave del Tipo de Proveedor Logístico]",
                descripcion: "[Descripción del Tipo de Proveedor Logístico]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 50
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 350
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
    .v-card--material{
    min-height: 750px !important;
    }
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>